import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getOptedCampaignsListByBrandFailure, getOptedCampaignsListByBrandSuccess } from '../../actions/CreateCampaignActions/getOptedCampaignsListByBrandAction';

function* getOptedCampaignsListByBrand({ payload ,callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getOptedCampaignsListByBrand + '?campaignId=' + payload.campaignId,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_SUCCESS status :", response.data.status);
        console.log("GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_SUCCESS data :", response.data.response);
        console.log("GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getOptedCampaignsListByBrandSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_FAILURE status :", error?.response?.status);
        console.log("GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_FAILURE data:", error?.response?.data);
        console.log("GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_FAILURE error :", error);
        console.log('====================================');
        yield put(getOptedCampaignsListByBrandFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getOptedCampaignsListByBrandSaga() {
    yield takeLatest(actionTypes.GET_OPTED_CAMPAIGNS_LIST_BY_BRAND_REQUEST, getOptedCampaignsListByBrand);
}

export default getOptedCampaignsListByBrandSaga;
